import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setImages } from "../../features/images/imageSlice";
import ApiCustom from "../../utils/ApiCustom";

const ImageCarousel = () => {
  const dispatch = useDispatch();
  const images = useSelector((state) => state.images.images);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    getBannerImage();
  }, []);

  const getBannerImage = () => {
    ApiCustom.get("/get-media-with-banner")
      .then((res) => {
        const imageUrls = res.data?.data?.images?.map((item) => item.url) || [];
        dispatch(setImages(imageUrls));
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1,
      );
    }, 3000);

    return () => clearInterval(interval);
  }, [images]);

  return (
    <div className="carousel w-full overflow-hidden relative h-200 mb-4">
      <div
        className="flex transition-transform duration-700 ease-in-out"
        style={{
          transform: `translateX(-${currentIndex * 100}%)`,
        }}
      >
        {images.map((image, index) => (
          <div
            key={`carousel-image-${index}`}
            className={`carousel-item relative w-full transition-opacity duration-500 ease-in-out ${"opacity-100"}`}
          >
            <div className="w-full" style={{ aspectRatio: "1140/400" }}>
              <img
                src={image}
                alt={`Slide ${index + 1}`}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageCarousel;
